import { CalculationEngineMonthlyValueOverrides, FarmerMarginCalculatorModel, RunCalculationEngineResponse } from '../../../../../Generated/Raven-Demeter';
import { TrackingEvent } from '../../../../Services/Tracking/TrackingService';
import { HideGroup, MarginCompositeModel, TabEventKeyType } from '../../RiskDefinitions';
import MarginInput from './MarginInput';

interface IMarginInputProps {
    getFarmerMarginCalculatorCompositeRowsModel: MarginCompositeModel[];
    runCalculationEngineResponse: RunCalculationEngineResponse;
    savedFarmerMarginCalculator?: FarmerMarginCalculatorModel;
    runMonthlyValueOverrides: Array<CalculationEngineMonthlyValueOverrides> | null;
    setRunMonthlyValueOverrides: (runMonthlyValueOverrides: Array<CalculationEngineMonthlyValueOverrides> | null) => void;
    className: string;
    ancestors?: string[];
    hideGroup: HideGroup;
    fieldName: string;
    disabled?: boolean;
    handleGridTabNavigation: (columnIndex: number, rowIndex: number, direction: TabEventKeyType) => void;
    validation?: RegExp;
    track: TrackingEvent;
}

const MarginInputRow: React.FC<IMarginInputProps> = (props: IMarginInputProps) => (
    <div className={props.className}>
        {props.getFarmerMarginCalculatorCompositeRowsModel?.map((x, index) => (
            <MarginInput
                key={`input_${props.fieldName}_${x.asOfDate}`}
                getFarmerMarginCalculatorCompositeRowsModel={props.getFarmerMarginCalculatorCompositeRowsModel}
                runCalculationEngineResponse={props.runCalculationEngineResponse}
                savedFarmerMarginCalculator={props.savedFarmerMarginCalculator}
                runMonthlyValueOverrides={props.runMonthlyValueOverrides}
                setRunMonthlyValueOverrides={props.setRunMonthlyValueOverrides}
                fieldName={props.fieldName}
                ancestors={props.ancestors}
                hideGroup={props.hideGroup}
                disabled={props.disabled}
                index={index}
                handleGridTabNavigation={props.handleGridTabNavigation}
                validation={props.validation}
                track={props.track}
            />
        ))}
    </div>
);

export default MarginInputRow;
